'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import l from "../defs/Image.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var a = (m, e, o) => e in m ? i(m, e, { enumerable: true, configurable: true, writable: true, value: o }) : m[e] = o, t = (m, e) => {
  for (var o in e || (e = {}))
    c.call(e, o) && a(m, o, e[o]);
  if (r)
    for (var o of r(e))
      I.call(e, o) && a(m, o, e[o]);
  return m;
}, f = (m, e) => p(m, s(e));
const w = forwardRef((m, e) => /* @__PURE__ */ a__default.createElement(b, f(t({ ref: e }, m), { weights: l })));
w.displayName = "Image";
export {
  w as Image
};
